var _excluded = ["children", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var halfSpacing = 'calc(var(--spacing-1) / 2)';
var variantStyle = {
  small: {
    font: 'var(--body-text-x-small)',
    padding: "calc(var(--spacing-1) + ".concat(halfSpacing, ") var(--spacing-1) ").concat(halfSpacing)
  },
  medium: {
    font: 'var(--body-text-x-small)',
    padding: "calc(var(--spacing-2) + ".concat(halfSpacing, ") var(--spacing-2) ").concat(halfSpacing)
  },
  large: {
    font: 'var(--body-text-small)',
    padding: 'var(--spacing-3) var(--spacing-3) var(--spacing-1)'
  }
};
// TODO(Kameron Ahler): is this refactorable if EyebrowText is revamped?
var StyledLi = styled.li.withConfig({
  componentId: "CL__sc-6cpc3w-0"
})(["color:var(--border-color);font:", ";letter-spacing:0.0982em;list-style:none;padding:", ";cursor:default;text-transform:uppercase;&&{font-weight:600;}"], _ref => {
  var {
    $size
  } = _ref;
  return variantStyle[$size].font;
}, _ref2 => {
  var {
    $size
  } = _ref2;
  return variantStyle[$size].padding;
});
var DropdownMenuHeading = _ref3 => {
  var {
      children,
      size = 'medium'
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledLi, _extends({
    role: "heading",
    $size: size
  }, props), children);
};
export default DropdownMenuHeading;